import React, { useState } from "react";
import { Button } from "../design/button";
import EventDialog from "./Dialogs/EventDialog/EventDialog";
import {Event} from "../models/Event";
import { PlusIcon } from "@heroicons/react/16/solid";
import { EventTag } from "../models/EventTag";

interface Props {
  children?: React.ReactNode;
  date?: Date;
  event?: Event;
  eventTags?: EventTag["_id"][];
}

const EventButton: React.FC<Props> = ({ event, date, children, eventTags }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Button type="button" onClick={() => setIsOpen(true)}>
        {children ?? (
          <div className="flex items-center gap-2">
            {!event && <PlusIcon className="w-4 h-4" />}
            <span className="hidden sm:block">
              {event ? "Edit Event" : "Create Event"}
            </span>
          </div>
        )}
      </Button>
      <EventDialog
        initialDate={date}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        event={event}
        initialEventTags={eventTags}
    />
    </>
  );
};

export default EventButton;
